type IdLike = { _id?: string; id?: string; sub?: string };

export const normalizeId = (value: string | IdLike | null | undefined): string | undefined => {
  if (typeof value === 'string') {
    return value;
  }
  if (value?._id) {
    return value._id;
  }
  if (value?.id) {
    return value.id;
  }
  return undefined;
};

export const normalizeLeadIds = (
  value: string | IdLike | Array<string | IdLike> | null | undefined
): (null | string)[] => {
  if (value === null) {
    return [];
  }
  let list: Array<string | IdLike> = [];
  if (Array.isArray(value)) {
    list = value;
  } else if (value) {
    list = [value];
  }
  return list
    .map((item) => {
      if (!item) {
        return null;
      }
      if (typeof item === 'string') {
        return item;
      }
      return item.sub ?? null;
    })
    .filter(Boolean);
};
